import { apiClient } from './ApiClient';

export const fetchModelDataAPI = async (organization) => {
  const action = "getModelData";
  const response = await apiClient.get('modelmanagement', {
    params: { organization, action }
  });
  const models = Array.isArray(response.data.models) ? response.data.models : [];
  return models;
};

export const fetchDatasetsAPI = async (organization) => {
  const response = await apiClient.get('datamanagement', {
    params: { organization }
  });

  const rawMetadata = response.data.folderMetadata || [];
  const datasets = rawMetadata.map(item => ({
    folderName: item.folderName,
    updatedttm: item.updatedttm,
    file_count: item.file_count,
    num_classes: item.num_classes
  }));

  return datasets;
};

export const buildModelAPI = async (organization, username, buildParams) => {
  console.log("buildParams: ", buildParams);
  const requestBody = {
    action: "buildModel",
    organization,
    username,
    ...buildParams
  };

  console.log(requestBody);

  const response = await apiClient.post('modelmanagement', requestBody);
  return response.data;
};

export const downloadModelAPI = async (organization, zipModelPath) => {
  const requestBody = {
    action: "downloadModel",
    organization,
    zipModelPath
  };

  const response = await apiClient.post('modelmanagement', requestBody);
  return {
    downloadUrl: response.data.downloadUrl,
    fileName: response.data.fileName
  };
};


export const getTrainEstimateAPI = async (
  organization,
  num_classes,
  batch_size,
  num_steps,
  training_start_point
) => {
  const response = await apiClient.get('modelmanagement', {
    params: {
      action: "getTrainEstimate",
      organization,
      num_classes,
      batch_size,
      num_steps,
      training_start_point
    }
  });
  return response.data;
};


export const fetchSubmittedBuildsAPI = async (organization) => {
  const response = await apiClient.post("modelmanagement", {
    action: "fetchInProgressBuilds",
    organization,
  });

  let body = response?.data?.body ?? response?.data ?? response;
  if (typeof body === "string") {
    try { body = JSON.parse(body); } catch { body = {}; }
  }

  // If still proxy-wrapped like { statusCode, headers, body: "…" }
  if (body && typeof body === "object" && typeof body.body === "string") {
    try { body = JSON.parse(body.body); } catch { /* ignore */ }
  }

  // Accept both new and legacy shapes
  let builds = body?.builds ?? body?.message?.builds ?? [];

  if (typeof builds === "string") {
    try {
      const parsed = JSON.parse(builds);
      builds = Array.isArray(parsed) ? parsed : (parsed.builds ?? []);
    } catch { builds = []; }
  }

  return Array.isArray(builds) ? builds : [];
};


export const checkEC2StatusAPI = async (organization, username, includeScript) => {
  const response = await apiClient.post("modelmanagement", {
    action: "getStatus",
    organization,
    username,
    includeScript,
  });
  return response.data;
};


export const startEC2API = async (organization, username) => {
  const response = await apiClient.post("modelmanagement", {
    action: "startEC2",
    organization,
    username,
  });
  return response.data;
};


export const deleteModelAPI = async (organization, username, modelName) => {
    const response = await apiClient.post("modelmanagement", {
        action: "deleteModel",
        region: "us-east-1",
        organization,
        username,
        model_name: modelName
      });
    return response.data;
};


export const fetchModelConfigAPI = async (org, modelName, stepK) => {
  return apiClient.get('modelmanagement', {
    params: { organization: org, action: 'getModelConfig', modelName, stepK }
  });
};


export const stopTrainingAPI = async (organization, modelName) => {
  const action = "stopTraining";
  const response = await apiClient.post("modelmanagement", {
    action,
    organization,
    modelName,
  });
  return response.data;
};


export const exportCheckpointAPI = (
  organization,
  username,
  dataset,
  modelName,
  step,
  startedTime,
  instanceId
) => {
  const payload = {
    action: "exportCheckpoint",
    organization,
    username,
    dataset,
    modelName,
    step,
    startedTime,
  };

  // Only send if we actually have one; backend can still fall back to DynamoDB otherwise
  if (instanceId) {
    payload.instanceId = instanceId;
  }

  return apiClient
    .post("modelmanagement", payload) 
    .then((res) => res.data);
};



export const getInstanceIdAPI = ({ organization, username }) =>
  apiClient
    .post("/modelmanagement", {
      action: "getInstanceId",
      organization,
      username,
    })
    .then((res) => res.data);




